import React from 'react';
import Dashboard from '../features/dashboard/Dashboard';

const DashboardPage: React.FC = () => {
    return <Dashboard />;
};

export default DashboardPage;
